import type React from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import { SectionIntro } from '#src/app/pages/about/impact/shared/components';

import { WhoUsesCard } from './components/WhoUsesCard';
import { WHO_USES_CARDS } from './consts';

export const WhoUses: React.FC<EmptyProps> = () => {
	return (
		<section className="container flex flex-col gap-10 pb-16 md:gap-14 md:pb-32">
			<SectionIntro
				eyebrow={translationKey('corgi.impact_page.who_uses.eyebrow')}
				heading={translationKey('corgi.impact_page.who_uses.heading')}
				align="center"
			/>
			<div className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,200px),1fr))] gap-5">
				{WHO_USES_CARDS.map(({ id, ...card }) => (
					<WhoUsesCard key={id} {...card} />
				))}
			</div>
		</section>
	);
};
